document.addEventListener("DOMContentLoaded", () => {
  const initTruncatedText = (element) => {
    const content = element.querySelector("[data-content]");
    const toggleButton = element.querySelector("[data-toggle]");
    const moreText = element.querySelector("[data-more-text]");
    const lessText = element.querySelector("[data-less-text]");

    if (!content || !toggleButton) return;

    const originalText = content.textContent.trim();
    const charLimit = parseInt(element.dataset.symbols || "300");

    content.style.display = "block";

    if (originalText.length <= charLimit) {
      toggleButton.style.display = "none";
      return;
    }

    const truncatedText = originalText.slice(0, charLimit) + "...";

    content.textContent = truncatedText;

    toggleButton.style.display = "block";
    moreText.style.display = "inline";
    lessText.style.display = "none";
    toggleButton.setAttribute("aria-expanded", "false");

    toggleButton.addEventListener("click", function () {
      const isExpanded = this.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        content.textContent = truncatedText;
        moreText.style.display = "inline";
        lessText.style.display = "none";
        this.setAttribute("aria-expanded", "false");
      } else {
        content.textContent = originalText;
        moreText.style.display = "none";
        lessText.style.display = "inline";
        this.setAttribute("aria-expanded", "true");
      }
    });
  };

  document.querySelectorAll("[data-truncated-text]").forEach(initTruncatedText);
});
